import script from "./SendMailDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./SendMailDialog.vue?vue&type=script&lang=ts&setup=true"

import "./SendMailDialog.vue?vue&type=style&index=0&id=08f5e570&scoped=true&lang=css"

import exportComponent from "E:\\workspace13\\aries-backend-front\\kailas-aries\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_64f3209c872a893711b3e776f2c9ff1e\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08f5e570"]])

export default __exports__